import styled from 'styled-components';

const BoxedInputWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    height: 3.125rem;
    width: 100%;

    position: relative;

    border: 0.063rem solid ${props => props.disabled ? '#AAAAAA' : props.theme.color};
    box-sizing: border-box;
    padding: 0.75rem 1.25rem;

    font-size: 1rem;

    & > *:not(:last-child) {
        margin-right: 1rem;
    }
`;

export default BoxedInputWrap;
